module.exports = __webpack_public_path__ + "static/media/timeline5.0a0389a1.png";